export type CreditAvailability = { balance: number } | null | undefined;

export function isActionBlockedForCredits({
  creditsInfo,
  cost,
}: {
  creditsInfo: CreditAvailability;
  cost: number;
}): boolean {
  return (
    creditsInfo !== undefined &&
    creditsInfo !== null &&
    creditsInfo.balance < cost
  );
}

export function shouldShowCreditBlockTooltip({
  creditsInfo,
  cost,
  disabled,
}: {
  creditsInfo: CreditAvailability;
  cost: number;
  disabled: boolean;
}): boolean {
  return (
    !disabled &&
    isActionBlockedForCredits({
      creditsInfo,
      cost,
    })
  );
}
